<div class="wrapper__headerComponent container mt-3 mt-md-5">
  <div class="row">
    <div class="d-flex flex-row align-items-center align-items-md-start">
      <img
        src="../../../../assets/img/file-alt.svg"
        alt="logo"
        class="img-ico-form" />
      <h2 class="mb-0">{{"registry.crear_usuario"| translate}}</h2>
    </div>
  </div>
</div>
<div class="container wrapper__headerComponent d-flex flex-column gap-2" *ngIf="!showVideoSection">
  <div class="border__form rounded px-3 py-4">
    <div class="form-group" *ngIf="!showTermsSection">
      <div [formGroup]="tipoUsuarioForm">
        <div class="d-flex flex-row align-items-center">
          <label
            for="paginationSelect"
            class="form-label text3-tipografia-govco mb-0"
            >{{"registry.seleccione_usuario"| translate}}</label
          >
          <span class="text-danger">*</span>
        </div>
        <select
          formControlName="tipoUsuario"
          class="form-select"
          type="text"
          id="paginationSelect"
          (change)="getIdTipoUsuario()">
          <option value disabled>{{"registry.seleccione_opcion"| translate}}</option>
          <option *ngFor="let item of tipoUsuario" [value]="item.idTipoUsuario">
            {{ item.value }}
          </option>
        </select>
      </div>
    </div>
    <div class="border__form mt-4" *ngIf="showForm && !showTermsSection">
      <div class="alert alert-primary" role="alert" *ngIf="isCivicPerson">
        <h4 class="text-center mb-0">
          {{"registry.informacion_usuario"| translate}}
        </h4>
      </div>
      <div class="alert alert-primary" role="alert" *ngIf="isLawyer">
        <h4 class="text-center mb-0">
          {{"registry.informacion_abogado"| translate}}
        </h4>
      </div>
      <form [formGroup]="crearUsuarioForm">
        <div class="row mb-2">
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="primerNombre"
                  class="form-label text3-tipografia-govco mb-0"
                  >{{"registry.primer_nombre"| translate}}</label
                >
                <span class="text-danger">*</span>
              </div>
              <input
                type="text"
                class="form-control text3-tipografia-govco mb-0"
                id="primer_nombre"
                formControlName="primer_nombre"
                [placeholder]="registryText['nombre_placeholder']"
                (blur)="transformToUppercase('primer_nombre')"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('primer_nombre')?.valid &&
                    crearUsuarioForm.get('primer_nombre')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('primer_nombre')?.invalid &&
                    crearUsuarioForm.get('primer_nombre')?.touched,
                }"
                (input)="onInputChange($event, 25, 'primer_nombre')" />
              <div
                *ngIf="
                  crearUsuarioForm.get('primer_nombre')?.invalid &&
                  (crearUsuarioForm.get('primer_nombre')?.dirty ||
                    crearUsuarioForm.get('primer_nombre')?.touched)
                ">
                <span
                  *ngIf="
                    crearUsuarioForm.get('primer_nombre')?.errors?.['required']
                  "
                  class="text-danger">
                  {{"registry.nombre_required"| translate}}
                </span>
                <span
                  *ngIf="
                    crearUsuarioForm.get('primer_nombre')?.errors?.['pattern']
                  "
                  class="text-danger">
                  {{"registry.nombre_pattern"| translate}}
                </span>
                <span
                  *ngIf="
                    crearUsuarioForm.get('primer_nombre')?.errors?.[
                      'minlength'
                    ]
                  "
                  class="text-danger">
                  {{"registry.nombre_minlength"| translate}}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="primerNombre"
                  class="form-label text3-tipografia-govco mb-0"
                  >{{"registry.segundo_nombre"| translate}}</label
                >
              </div>
              <input
                type="text"
                class="form-control text3-tipografia-govco mb-0"
                id="segundo_nombre"
                formControlName="segundo_nombre"
                [placeholder]="registryText['segundo_nombre_placeholder']"
                (blur)="transformToUppercase('segundo_nombre')"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('segundo_nombre')?.valid &&
                    crearUsuarioForm.get('segundo_nombre')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('segundo_nombre')?.invalid &&
                    crearUsuarioForm.get('segundo_nombre')?.touched,
                }"
                (input)="onInputChange($event, 25, 'segundo_nombre')" />
              <div
                *ngIf="
                  crearUsuarioForm.get('segundo_nombre')?.invalid &&
                  (crearUsuarioForm.get('segundo_nombre')?.dirty ||
                    crearUsuarioForm.get('segundo_nombre')?.touched)
                ">
                <span
                  *ngIf="
                    crearUsuarioForm.get('segundo_nombre')?.errors?.['pattern']
                  "
                  class="text-danger">
                  {{"registry.segundo_nombre_pattern"| translate}}
                </span>
                <span
                  *ngIf="
                    crearUsuarioForm.get('segundo_nombre')?.errors?.[
                      'minlength'
                    ]
                  "
                  class="text-danger">
                  {{"registry.nombre_minlength"| translate}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="primerNombre"
                  class="form-label text3-tipografia-govco mb-0"
                  >{{"registry.primer_apellido"| translate}}</label
                >
                <span class="text-danger">*</span>
              </div>
              <input
                type="text"
                class="form-control text3-tipografia-govco mb-0"
                id="primer_apellido"
                formControlName="primer_apellido"
                [placeholder]="registryText['primer_apellido_placeholder']"
                (blur)="transformToUppercase('primer_apellido')"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('primer_apellido')?.valid &&
                    crearUsuarioForm.get('primer_apellido')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('primer_apellido')?.invalid &&
                    crearUsuarioForm.get('primer_apellido')?.touched,
                }"
                (input)="onInputChange($event, 25, 'primer_apellido')" />
              <div
                *ngIf="
                  crearUsuarioForm.get('primer_apellido')?.invalid &&
                  (crearUsuarioForm.get('primer_apellido')?.dirty ||
                    crearUsuarioForm.get('primer_apellido')?.touched)
                ">
                <span
                  *ngIf="
                    crearUsuarioForm.get('primer_apellido')?.errors?.[
                      'required'
                    ]
                  "
                  class="text-danger">
                  {{"registry.primer_apellido_required"| translate}}
                </span>
                <span
                  *ngIf="
                    crearUsuarioForm.get('primer_apellido')?.errors?.['pattern']
                  "
                  class="text-danger">
                  {{"registry.apellido_pattern"| translate}}
                </span>
                <span
                  *ngIf="
                    crearUsuarioForm.get('primer_apellido')?.errors?.[
                      'minlength'
                    ]
                  "
                  class="text-danger">
                  {{"registry.apellido_minlength"| translate}}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="primerNombre"
                  class="form-label text3-tipografia-govco mb-0"
                  >{{"registry.segundo_apellido"| translate}}</label
                >
              </div>
              <input
                type="text"
                class="form-control text3-tipografia-govco mb-0"
                id="segundo_apellido"
                formControlName="segundo_apellido"
                [placeholder]="registryText['segundo_apellido_placeholder']"
                (blur)="transformToUppercase('segundo_apellido')"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('segundo_apellido')?.valid &&
                    crearUsuarioForm.get('segundo_apellido')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('segundo_apellido')?.invalid &&
                    crearUsuarioForm.get('segundo_apellido')?.touched,
                }"
                (input)="onInputChange($event, 25, 'segundo_apellido')" />
              <div
                *ngIf="
                  crearUsuarioForm.get('segundo_apellido')?.invalid &&
                  (crearUsuarioForm.get('segundo_apellido')?.dirty ||
                    crearUsuarioForm.get('segundo_apellido')?.touched)
                ">
                <span
                  *ngIf="
                    crearUsuarioForm.get('segundo_apellido')?.errors?.[
                      'pattern'
                    ]
                  "
                  class="text-danger">
                  {{"registry.apellido_pattern"| translate}}
                </span>
                <span
                  *ngIf="
                    crearUsuarioForm.get('segundo_apellido')?.errors?.[
                      'minlength'
                    ]
                  "
                  class="text-danger">
                  {{"registry.apellido_minlength"| translate}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="primerNombre"
                  class="form-label text3-tipografia-govco mb-0"
                  >{{"registry.tipo_documento"| translate}}</label
                >
                <span class="text-danger">*</span>
              </div>
              <select
                formControlName="tipo_documento"
                class="form-select ms-1"
                type="text"
                id="paginationSelect"
                (change)="onDocumentTypeChange()"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('tipo_documento')?.valid &&
                    crearUsuarioForm.get('tipo_documento')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('tipo_documento')?.invalid &&
                    crearUsuarioForm.get('tipo_documento')?.touched,
                }">
                <option value disabled>{{"registry.seleccione_opcion"| translate}}</option>
                <option *ngFor="let item of tiposDocumento" [value]="item.Id">
                  {{ item.Descripcion }}
                </option>
              </select>
              <div
                *ngIf="
                  crearUsuarioForm.get('tipo_documento')?.invalid &&
                  (crearUsuarioForm.get('tipo_documento')?.dirty ||
                    crearUsuarioForm.get('tipo_documento')?.touched)
                ">
                <span
                  *ngIf="
                    crearUsuarioForm.get('tipo_documento')?.errors?.['required']
                  "
                  class="text-danger">
                  {{"registry.tipo_documento_required"| translate}}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="primerNombre"
                  class="form-label text3-tipografia-govco mb-0"
                  >{{"registry.numero_documento"| translate}}</label
                >
                <span class="text-danger">*</span>
              </div>
              <input
                type="text"
                class="form-control text3-tipografia-govco mb-0"
                id="numero_documento"
                formControlName="numero_documento"
                (input)="
                  onInputChange(
                    $event,
                    maxLengthIdentificacion,
                    'numero_documento'
                  )
                "
                [placeholder]="registryText['numero_documento_placeholder']"
                appTipoDocumentoValidation
                [allowedType]="allowedType"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('numero_documento')?.valid &&
                    crearUsuarioForm.get('numero_documento')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('numero_documento')?.invalid &&
                    crearUsuarioForm.get('numero_documento')?.touched,
                }" />
              <div
                *ngIf="
                  crearUsuarioForm.get('numero_documento')?.invalid &&
                  (crearUsuarioForm.get('numero_documento')?.dirty ||
                    crearUsuarioForm.get('numero_documento')?.touched)
                ">
                <span
                  *ngIf="
                    crearUsuarioForm.get('numero_documento')?.errors?.[
                      'required'
                    ]
                  "
                  class="text-danger">
                  {{"registry.numero_documento_required"| translate}}
                </span>
                <div *ngIf="crearUsuarioForm.get('tipo_documento')?.value">
                  <span
                    *ngIf="
                      crearUsuarioForm.get('numero_documento')?.errors?.[
                        'minlength'
                      ]
                    "
                    class="text-danger">
                    {{"registry.numero_documento_minlength"| translate}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="primerNombre"
                  class="form-label text3-tipografia-govco mb-0"
                  >{{"registry.fecha_nacimiento"| translate}}</label
                >
                <span class="text-danger">*</span>
              </div>
              <input
                type="date"
                class="form-control text3-tipografia-govco mb-0"
                id="fecha_nacimiento"
                formControlName="fecha_nacimiento"
                placeholder="Fecha de nacimiento"
                (input)="validarAnio($event)"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('fecha_nacimiento')?.valid &&
                    crearUsuarioForm.get('fecha_nacimiento')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('fecha_nacimiento')?.invalid &&
                    crearUsuarioForm.get('fecha_nacimiento')?.touched,
                }" />
              <div
                *ngIf="
                  crearUsuarioForm.get('fecha_nacimiento')?.invalid &&
                  (crearUsuarioForm.get('fecha_nacimiento')?.dirty ||
                    crearUsuarioForm.get('fecha_nacimiento')?.touched)
                ">
                <span
                  *ngIf="
                    crearUsuarioForm.get('fecha_nacimiento')?.errors?.[
                      'required'
                    ]
                  "
                  class="text-danger">
                  {{"registry.fecha_nacimiento_required"| translate}}
                </span>
                <span
                  *ngIf="
                    crearUsuarioForm.get('fecha_nacimiento')?.errors?.[
                      'edadRequerida'
                    ]
                  "
                  class="text-danger">
                  {{"registry.min_age"| translate}}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="nacionalidad"
                  class="form-label text3-tipografia-govco mb-0">
                  {{"datos-adicionales.nacionalidad"| translate}}
                </label>
              </div>
              <select
                formControlName="nacionalidad"
                class="form-select ms-1"
                type="text"
                id="nacionalidad">
                <option value disabled>{{"registry.seleccione_opcion"| translate}}</option>
                <option *ngFor="let item of paises" [value]="item.Id">
                  {{ item.Nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="pais"
                  class="form-label text3-tipografia-govco mb-0">
                  {{"comun-label.country"| translate}}
                </label>
                <span class="text-danger">*</span>
              </div>
              <select
                formControlName="pais"
                class="form-select ms-1"
                type="text"
                id="pais"
                (change)="obtenerDepartamentos($event)"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('pais')?.valid &&
                    crearUsuarioForm.get('pais')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('pais')?.invalid &&
                    crearUsuarioForm.get('pais')?.touched,
                }">
                <option value disabled>{{"registry.seleccione_opcion"| translate}}</option>
                <option *ngFor="let item of paises" [value]="item.Id">
                  {{ item.Nombre }}
                </option>
              </select>
              <div
              *ngIf="
                crearUsuarioForm.get('pais')?.invalid &&
                (crearUsuarioForm.get('pais')?.dirty ||
                  crearUsuarioForm.get('pais')?.touched)
              ">
              <span
                *ngIf="
                  crearUsuarioForm.get('pais')?.errors?.['required']
                "
                class="text-danger">
                {{"comun-label.country-required"| translate}}
              </span>
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="esColombia">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="departamento"
                  class="form-label text3-tipografia-govco mb-0">
                  {{"datos-adicionales.departamento"| translate}}
                </label>
                <span class="text-danger">*</span>
              </div>
              <select
                formControlName="departamento"
                class="form-select ms-1"
                type="text"
                id="departamento"
                (change)="obtenerMunicipios($event)"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('departamento')?.valid &&
                    crearUsuarioForm.get('departamento')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('departamento')?.invalid &&
                    crearUsuarioForm.get('departamento')?.touched,
                }">
                <option value disabled>{{"registry.seleccione_opcion"| translate}}</option>
                <option *ngFor="let item of departamentos" [value]="item.Id">
                  {{ item.Nombre }}
                </option>
              </select>
              <div
              *ngIf="
                crearUsuarioForm.get('departamento')?.invalid &&
                (crearUsuarioForm.get('departamento')?.dirty ||
                  crearUsuarioForm.get('departamento')?.touched)
              ">
              <span
                *ngIf="
                  crearUsuarioForm.get('departamento')?.errors?.['required']
                "
                class="text-danger">
                {{"comun-label.departament-required"| translate}}
              </span>
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="esColombia">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="municipio"
                  class="form-label text3-tipografia-govco mb-0">
                  {{"datos-adicionales.municipio"| translate}}
                </label>
                <span class="text-danger">*</span>
              </div>
              <select
                formControlName="municipio"
                class="form-select ms-1"
                type="text"
                id="municipio"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('municipio')?.valid &&
                    crearUsuarioForm.get('municipio')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('municipio')?.invalid &&
                    crearUsuarioForm.get('municipio')?.touched,
                }">
                <option value disabled>{{"registry.seleccione_opcion"| translate}}</option>
                <option *ngFor="let item of municipios" [value]="item.Id">
                  {{ item.Nombre }}
                </option>
              </select>
              <div
              *ngIf="
                crearUsuarioForm.get('municipio')?.invalid &&
                (crearUsuarioForm.get('municipio')?.dirty ||
                  crearUsuarioForm.get('municipio')?.touched)
              ">
              <span
                *ngIf="
                  crearUsuarioForm.get('municipio')?.errors?.['required']
                "
                class="text-danger">
                {{"comun-label.municipality-required"| translate}}
              </span>
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="!esColombia">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="otroDepartamento"
                  class="form-label text3-tipografia-govco mb-0">
                  {{"comun-label.departament"| translate}}
                </label>
                <span class="text-danger">*</span>
              </div>
              <input
                type="text"
                class="form-control"
                id="otroDepartamento"
                formControlName="otroDepartamento"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('otroDepartamento')?.valid &&
                    crearUsuarioForm.get('otroDepartamento')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('otroDepartamento')?.invalid &&
                    crearUsuarioForm.get('otroDepartamento')?.touched,
                }"
                (blur)="transformToUppercase('otroDepartamento')"/>
              <div
                *ngIf="
                  crearUsuarioForm.get('otroDepartamento')?.invalid &&
                  (crearUsuarioForm.get('otroDepartamento')?.dirty ||
                    crearUsuarioForm.get('otroDepartamento')?.touched)
                ">
                <span
                  *ngIf="crearUsuarioForm.get('otroDepartamento')?.errors?.['maxlength']"
                  class="text-danger">
                  {{"comun-label.department-maxlength"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('otroDepartamento')?.errors?.['required']"
                  class="text-danger">
                  {{"comun-label.departament-required"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('otroDepartamento')?.errors?.['pattern']"
                  class="text-danger">
                  {{"comun-label.department-pattern"| translate}}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="!esColombia">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="otroMunicipio"
                  class="form-label text3-tipografia-govco mb-0">
                  {{"comun-label.municipality"| translate}}
                </label>
                <span class="text-danger">*</span>
              </div>
              <input
                type="text"
                class="form-control"
                id="otroMunicipio"
                formControlName="otroMunicipio"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('otroMunicipio')?.valid &&
                    crearUsuarioForm.get('otroMunicipio')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('otroMunicipio')?.invalid &&
                    crearUsuarioForm.get('otroMunicipio')?.touched,
                }"
                (blur)="transformToUppercase('otroMunicipio')"/>
              <div
                *ngIf="
                  crearUsuarioForm.get('otroMunicipio')?.invalid &&
                  (crearUsuarioForm.get('otroMunicipio')?.dirty ||
                    crearUsuarioForm.get('otroMunicipio')?.touched)
                ">
                <span
                  *ngIf="
                    crearUsuarioForm.get('otroMunicipio')?.errors?.['required']
                  "
                  class="text-danger">
                  {{"comun-label.municipality-required"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('otroMunicipio')?.errors?.['maxlength']"
                  class="text-danger">
                  {{"comun-label.municipality-maxlength"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('otroMunicipio')?.errors?.['pattern']"
                  class="text-danger">
                  {{"comun-label.municipality-pattern"| translate}}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="direccion"
                  class="form-label text3-tipografia-govco mb-0">
                  {{"datos-adicionales.direccion"| translate}}
                </label>
                <span class="text-danger">*</span>
              </div>
              <input
                class="form-control"
                id="direccion"
                formControlName="direccion"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('direccion')?.valid &&
                    crearUsuarioForm.get('direccion')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('direccion')?.invalid &&
                    crearUsuarioForm.get('direccion')?.touched,
                }"
                (blur)="transformToUppercase('direccion')"/>
              <div
                *ngIf="
                  crearUsuarioForm.get('direccion')?.invalid &&
                  (crearUsuarioForm.get('direccion')?.dirty ||
                    crearUsuarioForm.get('direccion')?.touched)
                ">
                <span *ngIf="crearUsuarioForm.get('direccion')?.errors?.['required']"
                      class="text-danger">
                  {{"comun-label.direccion-notificacion-judicial-required"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('direccion')?.errors?.['pattern']"
                  class="text-danger">
                  {{"comun-label.direccion-notificacion-judicial-pattern"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('direccion')?.errors?.['minlength']"
                  class="text-danger">
                  {{"configuracion-cuenta.direccion-minlength"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('direccion')?.errors?.['maxlength']"
                  class="text-danger">
                  {{"datos-adicionales.direccion-maxlength"| translate}}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="telefono"
                  class="form-label text3-tipografia-govco mb-0">
                  {{"configuracion-cuenta.telefono"| translate}}
                </label>
                <span class="text-danger">*</span>
              </div>
              <input
                type="text"
                class="form-control"
                id="telefono"
                formControlName="telefono"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('telefono')?.valid &&
                    crearUsuarioForm.get('telefono')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('telefono')?.invalid &&
                    crearUsuarioForm.get('telefono')?.touched,
                }"/>
              <div
                *ngIf="
                  crearUsuarioForm.get('telefono')?.invalid &&
                  (crearUsuarioForm.get('telefono')?.dirty ||
                    crearUsuarioForm.get('telefono')?.touched)
                ">
                <span *ngIf="crearUsuarioForm.get('telefono')?.errors?.['required']"
                      class="text-danger">
                  {{"configuracion-cuenta.telefono-required"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('telefono')?.errors?.['pattern']"
                  class="text-danger">
                  {{"configuracion-cuenta.telefono-pattern"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('telefono')?.errors?.['minlength']"
                  class="text-danger">
                  {{"configuracion-cuenta.telefono-minlength"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('telefono')?.errors?.['maxlength']"
                  class="text-danger">
                  {{"configuracion-cuenta.telefono-maxlength"| translate}}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="isCivicPerson">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="correo"
                  class="form-label text3-tipografia-govco mb-0"
                >{{"registry.email"| translate}}</label
                >
                <span class="text-danger">*</span>
              </div>
              <input
                type="text"
                class="form-control"
                id="correoCivicPerson"
                formControlName="correo"
                [placeholder]="registryText['email_placeholder']"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('correo')?.valid &&
                    crearUsuarioForm.get('correo')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('correo')?.invalid &&
                    crearUsuarioForm.get('correo')?.touched,
                }"
                (blur)="transformToUppercase('correo')"/>
              <div
                *ngIf="
                  crearUsuarioForm.get('correo')?.invalid &&
                  (crearUsuarioForm.get('correo')?.dirty ||
                    crearUsuarioForm.get('correo')?.touched)
                ">
                <span
                  *ngIf="crearUsuarioForm.get('correo')?.errors?.['required']"
                  class="text-danger">
                  {{"registry.email_required"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('correo')?.errors?.['pattern']"
                  class="text-danger">
                  {{"registry.email_pattern"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('correo')?.errors?.['maxlength']"
                  class="text-danger">
                  {{"registry.email_maxlength"| translate}}
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-6" *ngIf="isLawyer">
            <div class="form-group">
              <div class="d-flex flex-row align-items-center">
                <label
                  for="correo"
                  class="form-label text3-tipografia-govco mb-0"
                >{{"registry.email"| translate}}</label
                >
                <span class="text-danger">*</span>
              </div>
              <input
                type="text"
                class="form-control"
                id="correoLawyer"
                formControlName="correo"
                [placeholder]="registryText['email_placeholder']"
                [ngClass]="{
                  'is-valid':
                    crearUsuarioForm.get('correo')?.valid &&
                    crearUsuarioForm.get('correo')?.touched,
                  'is-invalid':
                    crearUsuarioForm.get('correo')?.invalid &&
                    crearUsuarioForm.get('correo')?.touched,
                }" />
              <div
                *ngIf="
                  crearUsuarioForm.get('correo')?.invalid &&
                  (crearUsuarioForm.get('correo')?.dirty ||
                    crearUsuarioForm.get('correo')?.touched)
                ">
                <span
                  *ngIf="crearUsuarioForm.get('correo')?.errors?.['required']"
                  class="text-danger">
                  {{"registry.email_required"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('correo')?.errors?.['pattern']"
                  class="text-danger">
                  {{"registry.email_pattern"| translate}}
                </span>
                <span
                  *ngIf="crearUsuarioForm.get('correo')?.errors?.['maxlength']"
                  class="text-danger">
                  {{"registry.email_maxlength"| translate}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex flex-row justify-content-end my-3">
          <button
            type="button"
            (click)="goToTermsSection()"
            [disabled]="crearUsuarioForm.invalid"
            class="btn-govco fill-btn-govco hvr-shrink"
            aria-label="Siguiente">
            Siguiente
          </button>
        </div>
      </form>
    </div>
    <!-- Sección de términos y condiciones -->
    <div class="border__form mt-4" *ngIf="showForm && showTermsSection">
      <h4 class="mb-3">TÉRMINOS Y CONDICIONES</h4>
      <p>Para registrarte, debes aceptar nuestros términos de uso.</p>
      <div class="form-check mb-2">
        <input class="form-check-input" type="checkbox" id="privacyCheck" [(ngModel)]="acceptedPrivacy" name="privacyCheck">
        <label class="form-check-label" for="privacyCheck">
          Sí, he leído y comprendido la <button
            type="button"
            class="link-button"
            (click)="openPoliticaPrivacidadModal()"
            [attr.aria-label]="'Política de Privacidad'">
            Política de Privacidad
          </button>
        </label>
      </div>
      <div class="form-check mb-4">
        <input class="form-check-input" type="checkbox" id="termsCheck" [(ngModel)]="acceptedTerms" name="termsCheck">
        <label class="form-check-label" for="termsCheck">
          Sí, he leído y comprendido los <button
            type="button"
            class="link-button"
            (click)="openTerminosCondicionesModal()"
            [attr.aria-label]="'Términos y Condiciones'">
            Términos y Condiciones
          </button>
        </label>
      </div>
      <div class="d-flex flex-row justify-content-between">
        <button
          type="button"
          class="btn-govco fill-btn-govco hvr-shrink"
          (click)="goBackToForm()"
          aria-label="Atrás">
          Atrás
        </button>
        <button
          type="button"
          (click)="registerWithTerms()"
          [disabled]="!acceptedPrivacy || !acceptedTerms"
          class="btn-govco fill-btn-govco hvr-shrink"
          aria-label="Registrar">
          Registrar
        </button>
      </div>
    </div>
  </div>
  <div class="alert alert-info text-center" role="alert">
    {{"registry.sesion"| translate}}
    <a routerLink="/login" class="alert-link">{{"registry.aqui"| translate}}</a>.
  </div>
</div>
<app-modal-terminos #modalTerminos></app-modal-terminos>
